import { SearchItem } from '@/types/search.types';

export const searchIndexData: SearchItem[] = [
  {
    id: 'home',
    title: 'Home',
    category: 'Main',
    description:
      'Hera Flight: Private Jet Company offering charter flights, rentals, aircraft management, sales, and jet card memberships.',
    href: '/',
    keywords: ['hera flight', 'home', 'main', 'private jet', 'aviation'],
  },

  {
    id: 'charter',
    title: 'Charter Flights',
    category: 'Charter Flights',
    description:
      'Book a private jet charter flight for business or leisure travel. Choose your destination and aircraft type.',
    href: '/charter',
    keywords: [
      'charter',
      'private jet charter',
      'book a flight',
      'on-demand',
      'rent a jet',
      'hire a jet',
    ],
  },
  {
    id: 'empty-leg-flights',
    title: 'Empty Leg Flights',
    category: 'Charter Flights',
    description:
      'Save more on luxury one-way charters with last-minute private jet deals and empty leg specials.',
    href: '/empty-leg-flights',
    keywords: [
      'empty leg',
      'empty legs',
      'discount',
      'one-way',
      'last minute',
      'deals',
      'specials',
    ],
  },
  {
    id: 'request-a-quote',
    title: 'Request a Quote',
    category: 'Charter Flights',
    description:
      'Request a personalized quote for your next private jet flight with Hera Flight.',
    href: '/request-a-quote',
    keywords: ['quote', 'pricing', 'estimate', 'inquire', 'booking'],
  },
  {
    id: 'promotions',
    title: 'Promotions',
    category: 'Charter Flights',
    description:
      'Current promotions and special offers from Hera Flight on private jet travel.',
    href: '/promotions',
    keywords: ['promotions', 'offers', 'deals', 'discounts', 'specials'],
  },

  {
    id: 'services',
    title: 'Services',
    category: 'Services',
    description:
      'Private flight services between 22,000+ airport pairs in the U.S., plus aircraft management, sales, and jet card memberships.',
    href: '/services',
    keywords: ['services', 'aviation services', 'offerings'],
  },
  {
    id: 'aircraft-management',
    title: 'Aircraft Management',
    category: 'Services',
    description:
      'Full operational control, revenue optimization, maintenance coordination, and compliant charter placement for private jet owners.',
    href: '/aircraft-management',
    keywords: [
      'aircraft management',
      'manage my aircraft',
      'jet management',
      'owner services',
      'revenue',
    ],
  },
  {
    id: 'aircraft-sales',
    title: 'Aircraft Sales',
    category: 'Services',
    description:
      'Jets for sale from Hera Flight. Sign up for free listing alerts or find a specific aircraft to suit your needs.',
    href: '/aircraft-sales',
    keywords: [
      'aircraft sales',
      'jets for sale',
      'buy a jet',
      'sell a jet',
      'aircraft brokerage',
    ],
  },
  {
    id: 'maintenance',
    title: 'Aircraft Maintenance',
    category: 'Services',
    description:
      'Hera Flight leverages years of technical expertise for all your aircraft maintenance needs.',
    href: '/maintenance',
    keywords: ['maintenance', 'aircraft maintenance', 'mro', 'repair', 'servicing'],
  },

  {
    id: 'private-jet-to-miami',
    title: 'Private Jet to Miami',
    category: 'Destinations',
    description:
      'Premium private jet charter to and from Miami with exclusive aircraft, flexible scheduling, and world-class service.',
    href: '/private-jet-to-miami',
    keywords: ['miami', 'florida', 'mia', 'opf', 'south florida'],
  },
  {
    id: 'private-jet-to-new-york',
    title: 'Private Jet to New York',
    category: 'Destinations',
    description:
      'Seamless private aviation to and from New York with exclusive aircraft, flexible scheduling, and global connectivity.',
    href: '/private-jet-to-new-york',
    keywords: ['new york', 'nyc', 'manhattan', 'teterboro', 'jfk', 'lga', 'ny'],
  },
  {
    id: 'private-jet-to-los-angeles',
    title: 'Private Jet to Los Angeles',
    category: 'Destinations',
    description:
      'Premium private jet charter to and from Los Angeles with exclusive aircraft, flexible scheduling, and global connectivity.',
    href: '/private-jet-to-los-angeles',
    keywords: ['los angeles', 'la', 'lax', 'van nuys', 'california', 'hollywood'],
  },
  {
    id: 'private-jet-to-monaco',
    title: 'Private Jet to Monaco',
    category: 'Destinations',
    description:
      'Premium private jet charter to and from Monaco with exclusive aircraft, flexible scheduling, and global connectivity.',
    href: '/private-jet-to-monaco',
    keywords: ['monaco', 'monte carlo', 'europe', 'mediterranean', 'french riviera'],
  },
  {
    id: 'private-jet-to-palm-beach',
    title: 'Private Jet to Palm Beach',
    category: 'Destinations',
    description:
      'Premium private jet charter to and from Palm Beach with exclusive aircraft and flexible scheduling.',
    href: '/private-jet-to-palm-beach',
    keywords: ['palm beach', 'west palm beach', 'pbi', 'florida'],
  },
  {
    id: 'private-jet-orlando-fl',
    title: 'Private Jet to Orlando',
    category: 'Destinations',
    description:
      'Premium private jet charter to and from Orlando, Florida with exclusive aircraft and flexible scheduling.',
    href: '/private-jet-orlando-fl',
    keywords: ['orlando', 'florida', 'mco', 'disney', 'fl'],
  },
  {
    id: 'private-jet-new-orleans-la',
    title: 'Private Jet to New Orleans',
    category: 'Destinations',
    description:
      'Premium private jet charter to and from New Orleans, Louisiana with exclusive aircraft and flexible scheduling.',
    href: '/private-jet-new-orleans-la',
    keywords: ['new orleans', 'louisiana', 'msy', 'nola', 'la'],
  },

  {
    id: 'available-fleet',
    title: 'Available Fleet',
    category: 'Aircraft',
    description:
      'Browse the available fleet at Hera Flight. Find the most appropriate aircraft for your travels.',
    href: '/available-fleet',
    keywords: ['fleet', 'aircraft', 'planes', 'jets', 'available', 'browse'],
  },
  {
    id: 'citation-x',
    title: 'Cessna Citation X',
    category: 'Aircraft',
    description:
      'American long-range medium-sized business jet aircraft. One of the fastest civilian aircraft in the sky.',
    href: '/citation-x',
    keywords: [
      'citation x',
      'citation 10',
      'cessna',
      'super mid-size',
      'super midsize',
      'fast jet',
    ],
  },
  {
    id: 'falcon-2000',
    title: 'Dassault Falcon 2000',
    category: 'Aircraft',
    description:
      'High efficiency, productivity and performance with low direct operating costs. Elegant and affordable.',
    href: '/falcon-2000',
    keywords: ['falcon 2000', 'falcon', 'dassault', 'mid-size', 'midsize'],
  },
  {
    id: 'the-gulfstream-iv',
    title: 'Gulfstream IV',
    category: 'Aircraft',
    description:
      'Unparalleled luxury and performance. Up to 14 passengers in standard configuration; up to 19 in alternate.',
    href: '/the-gulfstream-iv',
    keywords: [
      'gulfstream iv',
      'gulfstream 4',
      'g4',
      'giv',
      'heavy jet',
      'long range',
    ],
  },

  {
    id: 'hera-10-hour-s-jet-program',
    title: 'Jet Card 10 Hours',
    category: 'Jet Card',
    description:
      'Private Jet Card 10 Hours. A simplified and cost-effective way to experience luxurious private jet travel.',
    href: '/hera-10-hour-s-jet-program',
    keywords: [
      'jet card',
      '10 hour',
      '10-hour',
      'ten hour',
      'membership',
      'card program',
    ],
  },
  {
    id: 'hera-jet-card-membership',
    title: 'Jet Card 25 Hours',
    category: 'Jet Card',
    description:
      'Private Jet Card Membership. Book a simplified and cost-effective way to experience luxurious private jet travel.',
    href: '/hera-jet-card-membership',
    keywords: [
      'jet card',
      '25 hour',
      '25-hour',
      'twenty five hour',
      'membership',
      'card program',
    ],
  },

  {
    id: 'about',
    title: 'About Hera Flight',
    category: 'About',
    description:
      'Hera Flight is a leading provider of private jet charters, aircraft management, and sales.',
    href: '/about',
    keywords: ['about', 'company', 'who we are', 'history', 'story'],
  },
  {
    id: 'management',
    title: 'Management',
    category: 'About',
    description:
      'Professional management at Hera Flight ensures FAA compliance, safety oversight, maintenance planning, and crew coordination.',
    href: '/management',
    keywords: ['management', 'leadership', 'team', 'executives', 'founders'],
  },
  {
    id: 'hera-flight-race-team',
    title: 'Hera Flight Race Team',
    category: 'About',
    description:
      'Hera Flight Race Team sponsorship and partnership information.',
    href: '/hera-flight-race-team',
    keywords: ['race team', 'racing', 'sponsorship', 'motorsport', 'partnership'],
  },

  {
    id: 'jobs',
    title: 'Careers',
    category: 'Careers',
    description:
      'Career opportunities at Hera Flight. View our private aviation job postings and listings.',
    href: '/jobs',
    keywords: ['careers', 'jobs', 'employment', 'work', 'hiring', 'vacancies'],
  },
  {
    id: 'jobs-vacancy-pilot',
    title: 'Pilot Career',
    category: 'Careers',
    description: 'Pilot career opportunities available at Hera Flight.',
    href: '/jobs/vacancy-pilot',
    keywords: ['pilot', 'captain', 'first officer', 'flying job', 'aviation career'],
  },
  {
    id: 'jobs-vacancy',
    title: 'Operations Coordinator Career',
    category: 'Careers',
    description: 'Operations Coordinator career opportunities at Hera Flight.',
    href: '/jobs/vacancy',
    keywords: [
      'operations coordinator',
      'ops',
      'flight coordinator',
      'dispatcher',
    ],
  },

  {
    id: 'contact',
    title: 'Contacts',
    category: 'Contacts',
    description:
      'Contact us for personal flights, aircraft sales, or management. Request more information.',
    href: '/contact',
    keywords: ['contact', 'phone', 'email', 'address', 'get in touch', 'reach us'],
  },
  {
    id: 'blog',
    title: 'Blog',
    category: 'Main',
    description:
      'Latest blog articles, news updates, and information on private jet travel.',
    href: '/blog',
    keywords: ['blog', 'news', 'articles', 'updates', 'press'],
  },
];
